import React from 'react'
import * as styles from './redirection-info.module.css'

export default function RedirectionInfo() {
    return (
        <div className={styles.main}>
            Please wait while we are redirecting you to appropriate page...
        </div>
    )
}
